import { render } from "./EditUserInformation.vue?vue&type=template&id=2455365a&scoped=true"
import script from "./EditUserInformation.vue?vue&type=script&lang=js"
export * from "./EditUserInformation.vue?vue&type=script&lang=js"

import "./EditUserInformation.vue?vue&type=style&index=0&id=2455365a&scoped=true&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2455365a"]])

export default __exports__